import EntryPoint from "../../../presentational/customerItems/EntryPoint";
import { initialiseCustomerItems } from "../../../../state/actions";
import { useDispatch } from "react-redux";

const EntryPointContainer = props => {
  const dispatch = useDispatch();

  return (
    <EntryPoint
      initialise={initParams => dispatch(initialiseCustomerItems(initParams))}
      {...props}
    />
  );
};

export default EntryPointContainer;
